import { useEffect } from 'react';

import { PhilBotApp } from '@data';
import { connectSourceUrl } from '@data/api/auth';
import { usePhillConnections } from '@data/hooks/auth';

import { connectPopupReturnUrl, onConnectPopupBack, philBotReturnUrl } from './returnTrip';

/** Connects a source in a popup and re-reads the connections once it is back; a blocked popup leaves the page. */
export const useConnectSource = (beforeLeaving?: () => Promise<boolean>): ((app: PhilBotApp) => void) => {
  const { refetch: refetchConnections } = usePhillConnections();
  useEffect(() => onConnectPopupBack(() => refetchConnections()), [refetchConnections]);

  const leave = async (app: PhilBotApp): Promise<void> => {
    if (beforeLeaving && !(await beforeLeaving())) return;
    window.location.assign(connectSourceUrl(app, philBotReturnUrl()));
  };

  return (app: PhilBotApp): void => {
    const popup = window.open(
      connectSourceUrl(app, connectPopupReturnUrl()),
      'phill-connect',
      'popup,width=600,height=720',
    );
    if (!popup) leave(app);
  };
};
